<template>
  <nav class="navbar navbar-dark bg-dark fixed-top">
    <i @click="back" style="float:left; height:100%">
      <a class="fas fa-chevron-left" style="color:#fff"></a>
    </i>
    <span class="navbar-brand" v-html="title" href="#"></span>

    <RightMenuIcon></RightMenuIcon>
  </nav>
</template>
<script>
import RightMenuIcon from "@/components/RightMenuIcon/RightMenuIcon.vue";
export default {
  name: "TopNav",
  props: ["title"],
  components: {
    RightMenuIcon
  },
  methods: {
    back: function() {
      this.$emit("click-back");
    }
  }
};
</script>
<style lang="scss" scoped>
.navbar-brand {
  max-width: 80%;
  display: inline-block;
  /* overflow: auto; */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>

